import React, { useState, useEffect } from "react";
import axios from "axios";
import { MdOutlineAdd } from "react-icons/md";
import DataTable from "react-data-table-component";

// Helper function to format date (YYYY-MM-DD)
const formatDate = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
};

function LeadSquareLeads() {
    const today = new Date();
    const lastWeek = new Date();
    lastWeek.setDate(today.getDate() - 7);

    const [leads, setLeads] = useState([]);
    const [pageIndex, setPageIndex] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [fromDate, setFromDate] = useState(formatDate(lastWeek));
    const [toDate, setToDate] = useState(formatDate(today));
    const pageSize = 5;
    const fetchLeads = async () => {
        const payload = {
            Parameter: {
                FromDate: `${fromDate} 00:00:00`,
                ToDate: `${toDate} 23:59:59`,
            },
            Columns: {
                Include_CSV: "ProspectID,FirstName,LastName,EmailAddress,Phone,Source,mx_Programme",
            },
            Paging: {
                PageIndex: pageIndex,
                PageSize: pageSize,
            },
            Sorting: {
                ColumnName: "ProspectAutoId",
                Direction: "1",
            },
        };

        const config = {
            method: "post",
            maxBodyLength: Infinity,
            url: `https://api-in21.leadsquared.com/v2/LeadManagement.svc/Leads.RecentlyModified?accessKey=u$r1d64e7e490a71e5105cf6a1a3efcd1fe&secretKey=${process.env.REACT_APP_SECRET_KEY}`,
            headers: {
                "Content-Type": "application/json",
            },
            data: JSON.stringify(payload),
        };

        try {
            const response = await axios.request(config);
            const records = response.data?.Leads || [];
            const total = parseInt(response.data?.RecordCount || "0");

            const cleanedLeads = records.map((lead) => {
                const entry = {};
                lead.LeadPropertyList.forEach((prop) => {
                    entry[prop.Attribute] = prop.Value;
                });
                return entry;
            });

            setLeads(cleanedLeads);
            setTotalRecords(total);
        } catch (error) {
            console.error("Failed to fetch leads", error);
        }
    };

    useEffect(() => {
        fetchLeads();
    }, [pageIndex]);

    const handleFilter = () => {
        setPageIndex(1);
        fetchLeads();
    };

    const columns = [
        { name: "CreatedOn", selector: (row) => row.CreatedOn },
        { name: "Prospect ID", selector: (row) => row.ProspectID },
        { name: "Last Name", selector: (row) => row.LastName },
        { name: "Email", selector: (row) => row.EmailAddress },
        { name: "Phone", selector: (row) => row.Phone },
        { name: "Source", selector: (row) => row.Source },
        { name: "mx_Programme", selector: (row) => row.mx_Programme },

    ];

    return (
        <div className="container mt-4">


            <div className="row g-3 mb-3">
                <div className="col-md-4">
                    <label className="form-label">From Date</label>
                    <input
                        type="date"
                        className="form-control"
                        value={fromDate}
                        onChange={(e) => setFromDate(e.target.value)}
                    />
                </div>
                <div className="col-md-4">
                    <label className="form-label">To Date</label>
                    <input
                        type="date"
                        className="form-control"
                        value={toDate}
                        onChange={(e) => setToDate(e.target.value)}
                    />
                </div>
                <div className="col-4 d-flex justify-content-end">
                    <button className="btn btn-primary w-50" onClick={handleFilter}>
                        Apply Filter
                    </button>
                </div>
            </div>

            <DataTable
                columns={columns}
                data={leads}
                pagination={false}
                responsive
                striped
                highlightOnHover
                noDataComponent={<div className="text-center text-muted py-3">No leads available</div>}
            />

            <div className="d-flex justify-content-between align-items-center mt-4">
                <button
                    className="btn btn-outline-secondary"
                    onClick={() => setPageIndex((prev) => Math.max(prev - 1, 1))}
                    disabled={pageIndex === 1}
                >
                    Previous
                </button>
                <span>
                    Page {pageIndex} of {Math.ceil(totalRecords / pageSize)}
                </span>
                <button
                    className="btn btn-outline-secondary"
                    onClick={() => setPageIndex((prev) => (prev * pageSize < totalRecords ? prev + 1 : prev))}
                    disabled={pageIndex * pageSize >= totalRecords}
                >
                    Next
                </button>
            </div>
        </div>
    );
}

export default LeadSquareLeads;
